export const MEDPLUM_RATE_LIMIT_ERROR_MESSAGE = 'Too Many Requests';

export function getRateLimitAlert(
  message = 'The system temporarily limited how fast we can load the data. Wait a few seconds before trying again.'
) {
  return { title: 'Too many requests', message };
}

export function isMedplumRateLimitError(error: unknown): boolean {
  let message = '';

  if (typeof error === 'string') {
    message = error;
  } else if (
    error &&
    typeof error === 'object' &&
    'message' in error &&
    typeof (error as { message: unknown }).message === 'string'
  ) {
    message = (error as { message: string }).message;
  }

  return message.length > 0 && message.toLowerCase().includes('too many requests');
}
